/**
 * useUser
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'
import UserContext from './user-context'

const useUser = () => {
  const context = useContext(UserContext)
  return context
}

export default useUser
